// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_list from "../../../../../../node_modules/rescript/lib/es6/js_list.js";
import * as Caml_obj from "../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PlaceOrderData from "../../../place-order/app/entity/PlaceOrderData.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as CustomerApiHandler from "../state-machine/CustomerApiHandler.bs.js";
import * as FilterOrderRequest from "../../../filter-order/entity/FilterOrderRequest.bs.js";
import * as CustomerOrderTableCmp from "./CustomerOrderTableCmp.bs.js";
import * as PlaceOrderDataMachine from "../../../place-order/app/data-machine/PlaceOrderDataMachine.bs.js";
import * as PlaceOrderContainerCmp from "../../../place-order/view/components/PlaceOrderContainerCmp.bs.js";
import * as CustomerOrderStateMachine from "../state-machine/CustomerOrderStateMachine.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";

function CustomerOrderTableWrapper(Props) {
  var uuid = Props.uuid;
  var mobile = Props.mobile;
  var customer_id = Props.customer_id;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(CustomerOrderStateMachine.StateMachine.machine, /* Init */0);
  var dispatch = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setLoader = match$2[1];
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match$3 = React.useState(function () {
        return false;
      });
  var setShowPlaceOrderPanel = match$3[1];
  var match$4 = React.useState(function () {
        return "";
      });
  var setSelectedRebookCRN = match$4[1];
  var match$5 = React.useState(function () {
        return PlaceOrderData.initialState;
      });
  var setPlaceOrderData = match$5[1];
  var plcaeOrderData = match$5[0];
  var fetchCustomerOrder = function (uuid, page_size, last_date_timestamp) {
    return function (param) {
      return CustomerApiHandler.FetchCustomerOrder.execute((function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* SetCustomerOrder */0,
                                _0: data
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* SetCustomerOrderFailed */1,
                                _0: error
                              });
                  }), uuid, page_size, last_date_timestamp, param);
    };
  };
  var onClosePlaceOrderPanel = function (param) {
    return Curry._1(setShowPlaceOrderPanel, (function (param) {
                  return false;
                }));
  };
  React.useEffect((function () {
          fetchCustomerOrder(uuid, 20, undefined)(country);
          
        }), []);
  var createWayPoint = function (data, id) {
    if (data !== undefined) {
      return {
              address: {
                latLng: data.place.location,
                address1: data.place.landmark,
                address2: data.place.doorstep_address,
                senderName: data.contact.name,
                senderNumber: data.contact.number
              },
              id: id,
              showForm: true
            };
    } else {
      return PlaceOrderData.initialWaypoint(id);
    }
  };
  var createWayPoints = function (wayPoints) {
    return [
            createWayPoint(Js_list.nth(wayPoints, 0), /* First */1),
            createWayPoint(Js_list.nth(wayPoints, 1), /* Second */2),
            createWayPoint(Js_list.nth(wayPoints, 2), /* Third */3)
          ];
  };
  if (typeof state === "number") {
    return React.createElement(LoadingViewComponent$Catalyst.make, {});
  } else if (state.TAG === /* CustomerOrder */0) {
    return React.createElement("div", {
                className: "customer-table-container"
              }, React.createElement("div", {
                    className: "header"
                  }, React.createElement("p", {
                        className: "title"
                      }, "Recent Order Details"), React.createElement(Button$Catalyst.make, {
                        text: "Open Order History",
                        cb: (function (_event) {
                            return Curry._2(workspaceDispatch.addTab, {
                                        TAG: /* FilterOrders */40,
                                        _0: FilterOrderRequest.toDict({
                                              order_id: undefined,
                                              customer_mobile: mobile,
                                              email: undefined,
                                              msisdn: undefined,
                                              driver_mobile: undefined,
                                              source: undefined,
                                              order_status: undefined,
                                              geo_region: undefined,
                                              order_type: undefined,
                                              start_datetime: undefined,
                                              end_datetime: undefined,
                                              brand: undefined,
                                              virtual_number: undefined,
                                              is_dn_requested: undefined,
                                              is_business: undefined
                                            })
                                      }, false);
                          }),
                        className: "btn-secondary"
                      })), match$2[0] ? React.createElement("div", {
                      className: "loader-wrapper"
                    }, React.createElement(LoadingViewComponent$Catalyst.make, {})) : null, React.createElement(CustomerOrderTableCmp.make, {
                    data: state._0,
                    updateTable: (function (end_time) {
                        if (Caml_obj.caml_equal(end_time, "0")) {
                          return ;
                        } else {
                          Curry._1(setLoader, (function (param) {
                                  return true;
                                }));
                          return CustomerApiHandler.FetchCustomerOrder.execute((function (data) {
                                        Curry._1(setLoader, (function (param) {
                                                return false;
                                              }));
                                        return Curry._1(dispatch, {
                                                    TAG: /* UpdateCustomerOrder */2,
                                                    _0: data
                                                  });
                                      }), (function (error) {
                                        Curry._1(setLoader, (function (param) {
                                                return false;
                                              }));
                                        return Curry._1(dispatch, {
                                                    TAG: /* UpdateCustomerOrderFailed */3,
                                                    _0: error
                                                  });
                                      }), uuid, 20, end_time, country);
                        }
                      }),
                    openPlaceOrder: (function (order_id) {
                        Curry._1(setSelectedRebookCRN, (function (param) {
                                return order_id;
                              }));
                        return PlaceOrderDataMachine.fetchOrder(order_id, country, (function (data) {
                                      switch (data.TAG | 0) {
                                        case /* Open */0 :
                                        case /* Accepted */1 :
                                        case /* Live */2 :
                                            break;
                                        default:
                                          var order = data._0;
                                          var drop_location = order.drop_info;
                                          if (drop_location === undefined) {
                                            return Curry._1(setSelectedRebookCRN, (function (param) {
                                                          return "";
                                                        }));
                                          }
                                          var pickup_address_latLng = order.pickup_info.place.location;
                                          var pickup_address_address1 = order.pickup_info.place.landmark;
                                          var pickup_address_address2 = order.pickup_info.place.doorstep_address;
                                          var pickup_address_senderName = order.pickup_info.contact.name;
                                          var pickup_address_senderNumber = order.pickup_info.contact.number;
                                          var pickup_address = {
                                            latLng: pickup_address_latLng,
                                            address1: pickup_address_address1,
                                            address2: pickup_address_address2,
                                            senderName: pickup_address_senderName,
                                            senderNumber: pickup_address_senderNumber
                                          };
                                          var drop_address_latLng = drop_location.place.location;
                                          var drop_address_address1 = drop_location.place.landmark;
                                          var drop_address_address2 = drop_location.place.doorstep_address;
                                          var drop_address_senderName = drop_location.contact.name;
                                          var drop_address_senderNumber = drop_location.contact.number;
                                          var drop_address = {
                                            latLng: drop_address_latLng,
                                            address1: drop_address_address1,
                                            address2: drop_address_address2,
                                            senderName: drop_address_senderName,
                                            senderNumber: drop_address_senderNumber
                                          };
                                          var match = createWayPoints(order.waypoints);
                                          var init = plcaeOrderData.selectedVehicle;
                                          var data_currentStep = plcaeOrderData.currentStep;
                                          var data_selectedVehicle = {
                                            vehicle_id: order.vehicle.vehicle_id,
                                            vehicle_name: init.vehicle_name,
                                            vehicle_imgs: init.vehicle_imgs,
                                            quotation_uuid: init.quotation_uuid,
                                            details: init.details,
                                            goods_type: init.goods_type,
                                            nearby_vehicles: init.nearby_vehicles,
                                            eta_mins: init.eta_mins,
                                            fare_info: init.fare_info,
                                            bill_details: init.bill_details
                                          };
                                          var data_geo_region = {
                                            id: order.geo_region_id,
                                            name: order.geo_region_name
                                          };
                                          var data_goods_type = plcaeOrderData.goods_type;
                                          var data_customerInfo = {
                                            mobile: mobile,
                                            customerId: customer_id
                                          };
                                          var data_snackbarMessage = plcaeOrderData.snackbarMessage;
                                          var data_wayPointOne = match[0];
                                          var data_wayPointTwo = match[1];
                                          var data_wayPointThree = match[2];
                                          var data_restricted_vehicles = plcaeOrderData.restricted_vehicles;
                                          var data_vehicles = plcaeOrderData.vehicles;
                                          var data_parentOrderId = {
                                            orderId: order.order_id,
                                            orderCRN: order.order_crn
                                          };
                                          var data_selectedGoodsType = order.goods_type_id;
                                          var data$1 = {
                                            currentStep: data_currentStep,
                                            pickupAddress: pickup_address,
                                            dropAddress: drop_address,
                                            selectedVehicle: data_selectedVehicle,
                                            geo_region: data_geo_region,
                                            goods_type: data_goods_type,
                                            customerInfo: data_customerInfo,
                                            isRebook: true,
                                            snackbarMessage: data_snackbarMessage,
                                            wayPointOne: data_wayPointOne,
                                            wayPointTwo: data_wayPointTwo,
                                            wayPointThree: data_wayPointThree,
                                            restricted_vehicles: data_restricted_vehicles,
                                            vehicles: data_vehicles,
                                            parentOrderId: data_parentOrderId,
                                            selectedGoodsType: data_selectedGoodsType
                                          };
                                          Curry._1(setSelectedRebookCRN, (function (param) {
                                                  return "";
                                                }));
                                          Curry._1(setPlaceOrderData, (function (param) {
                                                  return data$1;
                                                }));
                                          return Curry._1(setShowPlaceOrderPanel, (function (param) {
                                                        return true;
                                                      }));
                                      }
                                      return Curry._1(setSelectedRebookCRN, (function (param) {
                                                    return "";
                                                  }));
                                    }), (function (_error) {
                                      return Curry._1(setSelectedRebookCRN, (function (param) {
                                                    return "";
                                                  }));
                                    }));
                      }),
                    selectedRebookCRN: match$4[0]
                  }), match$3[0] ? React.createElement(PlaceOrderContainerCmp.make, {
                      onClosePlaceOrderPanel: onClosePlaceOrderPanel,
                      updatedInitialState: plcaeOrderData,
                      customerInfo: {
                        mobile: mobile,
                        customerId: customer_id
                      }
                    }) : null);
  } else {
    return null;
  }
}

var make = CustomerOrderTableWrapper;

export {
  make ,
  
}
/* react Not a pure module */
